export default {
	ACCOUNTING: 'companies/:company_id/accounting/',
}
